export default function validateDate(date: string): boolean {
  const dateChar = date.replace('/', '').replace('/', '').trim();
  if (dateChar.length !== 8) return false;

  const data = date.split('/');
  const isValid = new Date(`${data[2]}-${data[1]}-${data[0]}`);

  if (Number.isNaN(isValid.getTime())) return false;

  return true;
}
